import React from 'react';
import {useStyles} from "../MoneyExchanges.style";
import MoneyExchangeRowProperties from "./MoneyExchangeRowProperties";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoneyExchangeRateRangeItem from '../../../shared_components/Content/MoneyExchangeRateRangeItem/MoneyExchangeRateRangeItem';
import { useI18nContext } from '../../../contexts/I18nContext';
import NewMoneyExchangeRateButton from '../../../shared_components/Buttons/NewMoneyExchangeRateButton/NewMoneyExchangeRateButton';
import ButtonType from '../../../ui_components/Button/ButtonType';


const MoneyExchangeRowMedium: React.FC<MoneyExchangeRowProperties> = ({
                                                                          moneyExchange,
                                                                          onUpdate = () => {
                                                                          },
                                                                      }) => {

    const i18n = useI18nContext();
    const classes = useStyles();

    return (
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <div className={classes.currency_header}>{i18n.translate(moneyExchange.currency)}</div>
                </AccordionSummary>
                <AccordionDetails>
                    {moneyExchange.exchangeRateRanges.map((exchangeRateRange, i) => (
                        <MoneyExchangeRateRangeItem 
                            agencyId={moneyExchange.agencyId}
                            moneyExangeRateId={moneyExchange.id}
                            currency={moneyExchange.currency}
                            moneyExchangeRateRangeItem={exchangeRateRange}
                        />
                    ))}
                    <NewMoneyExchangeRateButton
                        className={classes.edit_exchange_rate_button}
                        moneyExchangeRateId={moneyExchange.id}
                        type={ButtonType.SECONDARY}
                        onSave={onUpdate}/>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default MoneyExchangeRowMedium;
